"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateHostToJSON = exports.templateHostFromJSON = exports.TemplateHost = void 0;
var TemplateHost;
(function (TemplateHost) {
  TemplateHost[TemplateHost["NEW_WORKSPACE"] = 0] = "NEW_WORKSPACE";
  TemplateHost[TemplateHost["ACTIVE_WORKSPACE"] = 1] = "ACTIVE_WORKSPACE";
  TemplateHost[TemplateHost["BROWSER_TAB"] = 2] = "BROWSER_TAB";
  TemplateHost[TemplateHost["DIALOG"] = 3] = "DIALOG";
  TemplateHost[TemplateHost["INLINE"] = 4] = "INLINE";
  TemplateHost[TemplateHost["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TemplateHost = exports.TemplateHost || (exports.TemplateHost = {}));
function templateHostFromJSON(object) {
  switch (object) {
    case 0:
    case "NEW_WORKSPACE":
      return TemplateHost.NEW_WORKSPACE;
    case 1:
    case "ACTIVE_WORKSPACE":
      return TemplateHost.ACTIVE_WORKSPACE;
    case 2:
    case "BROWSER_TAB":
      return TemplateHost.BROWSER_TAB;
    case 3:
    case "DIALOG":
      return TemplateHost.DIALOG;
    case 4:
    case "INLINE":
      return TemplateHost.INLINE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TemplateHost.UNRECOGNIZED;
  }
}
exports.templateHostFromJSON = templateHostFromJSON;
function templateHostToJSON(object) {
  switch (object) {
    case TemplateHost.NEW_WORKSPACE:
      return "NEW_WORKSPACE";
    case TemplateHost.ACTIVE_WORKSPACE:
      return "ACTIVE_WORKSPACE";
    case TemplateHost.BROWSER_TAB:
      return "BROWSER_TAB";
    case TemplateHost.DIALOG:
      return "DIALOG";
    case TemplateHost.INLINE:
      return "INLINE";
    case TemplateHost.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
exports.templateHostToJSON = templateHostToJSON;